/* ensure that share button is always last */
ion-button#share-button {
  order: 999;
}

concourse-header ion-header {
  box-shadow: none !important;
  max-width: 100%;
  overflow-x: hidden;
}

/* Toolbar flex row: allow the start segment to shrink instead of growing past the viewport */
concourse-header ion-toolbar::part(container) {
  min-width: 0;
  position: relative;
}

concourse-header ion-toolbar ion-buttons[slot='start'] {
  min-width: 0;
  flex-shrink: 1;
  overflow: hidden;
}

/*
 * ion-buttons :host sets transform: translateZ(0), which makes it the containing block for
 * position:absolute descendants — so .full-width-title stays trapped in the narrow start slot.
 */
concourse-header ion-toolbar ion-buttons[slot='start']:has(.full-width-title) {
  transform: none;
  overflow: visible;
  z-index: 101;
}

/* This fixes a very slight width change that makes the blue bg an oval */
concourse-header ion-button {
  width: auto !important;
  height: auto !important;
}

concourse-header {
  container-type: inline-size; /* or: size for width+height */
  container-name: card;
}

/* Apply styles to child elements when the parent container is smaller than 500px */
@container card (max-width: 650px) {
  .concourse-logo {
    display: none;
  }
}
/* stop the page title from pushing out of the header */
ion-title.page-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0; /* critical with flex to allow shrinking */
}

.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-icon {
  border: 1px solid rgba(0, 0, 0, 0); /*this is needed so blue bg surrounts the icon */
}

.header-icon-selected {
  border-radius: 50%;
  background-color: #2196f3;
  border: 1px solid #2196f3;
}

.profile-modal {
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .share-modal {
    --height: 700px;
  }
}

@media (max-width: 768px) {
  .share-modal {
    height: 100%;
  }
}

.profile-modal ion-header {
  margin-top: var(--ion-safe-area-top, 0);
}

.profile-component {
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: var(--ion-color-step-800);
  border-radius: 5px;
}

.profile-info {
  display: flex;
  flex-direction: column;
}

.profile-info h2 {
  margin: 0;
  font-size: 18px;
}

.profile-info p {
  margin: 0;
  font-size: 14px;
  color: var(--ion-color-medium);
}

.profile-modal ion-item:hover {
  text-decoration: underline;
  cursor: pointer;
}

.profile-modal concourse-avatar {
  --chip-avatar-size: 68px;
}

.profile-settings-modal ion-header {
  margin-top: var(--ion-safe-area-top, 0);
}

@media (min-width: 768px) {
  .profile-modal {
    justify-content: right;
    align-items: start;
    margin-top: 55px;
    --width: auto;
    --height: auto;
  }

  .profile-modal-close {
    display: none;
  }

  .profile-modal ion-content {
    min-height: 118px;
  }

  .profile-modal ion-list {
    margin: 0;
    padding: 0;
  }

  .profile-modal ion-header {
    min-width: 300px;
  }
}


/**
 * Because this is the second toolbar in the header, the native ionic safe area is not applied.
 * This is a fix to apply the safe area to the toolbar.
 */ 
 .full-width-toolbar {
  padding-top: var(--safe-area-inset-top, env(safe-area-inset-top, 0px));
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

ion-searchbar.cc-searchbar-mobile {
  text-align: left;
  width: 100%;
  --border-radius: 20px;
  --background: var(--ion-color-tertiary);
  --cancel-button-color: var(--ion-text-color);
}


.title-clip {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.title-clip.full-width-title {
  position: absolute;
  inset: 0;
  width: 100%;
  max-width: none;
  flex: none;
  z-index: 100;
  box-sizing: border-box;
}

/* ion-title :host uses flex:1 + horizontal padding; clip owns flex growth. */
.title-clip ion-title.title-text {
  flex: 1 1 0%;
  min-width: 0;
  padding: 0 !important;
  line-height: 1;
}

.title-measure {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  vertical-align: middle;
}

.title-clip.ticker-active ion-title.title-text.ticker {
  flex: 0 0 auto;
  max-width: none;
  width: max-content;
  min-width: max-content;
  overflow: visible;
  animation: ticker-scroll 12s ease-in-out infinite;
}

.title-clip.ticker-active .title-measure {
  max-width: none;
  overflow: visible;
  text-overflow: clip;
}

@keyframes ticker-scroll {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(0);
  }
  80% {
    transform: translateX(var(--ticker-distance));
  }
  100% {
    transform: translateX(var(--ticker-distance));
  }
}